import FleetManagementTable from './FleetManagementTable';

// eslint-disable-next-line import/prefer-default-export
export { FleetManagementTable };
